// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
export var AccountFeature;
(function (AccountFeature) {
    AccountFeature[AccountFeature["Balance"] = 0] = "Balance";
    AccountFeature[AccountFeature["BlockedBalance"] = 1] = "BlockedBalance";
    AccountFeature[AccountFeature["ProjectedBalance"] = 2] = "ProjectedBalance";
    AccountFeature[AccountFeature["MarginUsedPercent"] = 3] = "MarginUsedPercent";
    AccountFeature[AccountFeature["RiskLevelPercent"] = 4] = "RiskLevelPercent";
    AccountFeature[AccountFeature["MarginWarningLevel"] = 5] = "MarginWarningLevel";
    AccountFeature[AccountFeature["AvailableFunds"] = 6] = "AvailableFunds";
    AccountFeature[AccountFeature["WarningMargin"] = 7] = "WarningMargin";
    AccountFeature[AccountFeature["TotalMaintReq"] = 8] = "TotalMaintReq";
    AccountFeature[AccountFeature["WithdrawalAvailable"] = 9] = "WithdrawalAvailable";
    AccountFeature[AccountFeature["CashBalance"] = 10] = "CashBalance";
    AccountFeature[AccountFeature["MarginUsed"] = 11] = "MarginUsed";
    AccountFeature[AccountFeature["BalancePlusAllRisks"] = 12] = "BalancePlusAllRisks";
    AccountFeature[AccountFeature["MarginAvailable"] = 13] = "MarginAvailable";
    AccountFeature[AccountFeature["CreditValue"] = 14] = "CreditValue";
    AccountFeature[AccountFeature["EstimateValue"] = 15] = "EstimateValue";
    AccountFeature[AccountFeature["InterestRatePercent"] = 16] = "InterestRatePercent";
    AccountFeature[AccountFeature["BlockedForStocks"] = 17] = "BlockedForStocks";
    AccountFeature[AccountFeature["UnsettledCash"] = 18] = "UnsettledCash";
    AccountFeature[AccountFeature["StockValue"] = 19] = "StockValue";
    AccountFeature[AccountFeature["StocksOrdersReq"] = 20] = "StocksOrdersReq";
    AccountFeature[AccountFeature["OptionValue"] = 21] = "OptionValue";
    AccountFeature[AccountFeature["StocksLiquidity"] = 22] = "StocksLiquidity";
    AccountFeature[AccountFeature["CurrentTradingStatus"] = 23] = "CurrentTradingStatus";
    AccountFeature[AccountFeature["VolumeLimitForFutures"] = 24] = "VolumeLimitForFutures";
    AccountFeature[AccountFeature["VolumeLimitForOptions"] = 25] = "VolumeLimitForOptions";
    AccountFeature[AccountFeature["PowerOfAttorney"] = 26] = "PowerOfAttorney";
    AccountFeature[AccountFeature["WarnMarginReq"] = 27] = "WarnMarginReq";
    AccountFeature[AccountFeature["WarnMarginReqPercent"] = 28] = "WarnMarginReqPercent";
    AccountFeature[AccountFeature["MarginBeforeWarning"] = 29] = "MarginBeforeWarning";
    AccountFeature[AccountFeature["InitialMarginWithoutWaived"] = 30] = "InitialMarginWithoutWaived";
    AccountFeature[AccountFeature["BuyingPower"] = 31] = "BuyingPower";
    AccountFeature[AccountFeature["DayTraderPatternProtection"] = 32] = "DayTraderPatternProtection";
    AccountFeature[AccountFeature["AvailableDayTrades"] = 33] = "AvailableDayTrades";
    AccountFeature[AccountFeature["GivenLeverage"] = 34] = "GivenLeverage";
    AccountFeature[AccountFeature["OpenBalance"] = 35] = "OpenBalance";
    AccountFeature[AccountFeature["MaxRelativeDrawDownLevel"] = 36] = "MaxRelativeDrawDownLevel";
    AccountFeature[AccountFeature["StopOut"] = 37] = "StopOut";
    AccountFeature[AccountFeature["LossLimitPerTrade"] = 38] = "LossLimitPerTrade";
    AccountFeature[AccountFeature["IncomingFunds"] = 39] = "IncomingFunds";
    AccountFeature[AccountFeature["VolumeLimitForAll"] = 40] = "VolumeLimitForAll";
    //41,
    AccountFeature[AccountFeature["VolumeLimitForEquities"] = 42] = "VolumeLimitForEquities";
    //43,
    //44,
    //45,
    //46,
    //47,
    //48,
    //49,
    //50,
    //51,
    //52,
    //53,
    //54,
    //55,
    AccountFeature[AccountFeature["OpenNetPL"] = 56] = "OpenNetPL";
    AccountFeature[AccountFeature["WaivedMargin"] = 57] = "WaivedMargin";
    AccountFeature[AccountFeature["OptionPremiumReq"] = 58] = "OptionPremiumReq";
    AccountFeature[AccountFeature["OpenGrossPL"] = 59] = "OpenGrossPL";
    AccountFeature[AccountFeature["OpenPostionsNumber"] = 61] = "OpenPostionsNumber";
    AccountFeature[AccountFeature["OpenOrdersNumber"] = 62] = "OpenOrdersNumber";
    AccountFeature[AccountFeature["TodaysNetProfit"] = 63] = "TodaysNetProfit";
    AccountFeature[AccountFeature["TodaysFee"] = 64] = "TodaysFee";
    AccountFeature[AccountFeature["TodayGrossPNL"] = 65] = "TodayGrossPNL";
    AccountFeature[AccountFeature["TodayVolume"] = 66] = "TodayVolume";
    AccountFeature[AccountFeature["TodayTrades"] = 67] = "TodayTrades";
    AccountFeature[AccountFeature["EODTrailingDrawdownLevel"] = 68] = "EODTrailingDrawdownLevel";
    AccountFeature[AccountFeature["TodaysPnLPercent"] = 69] = "TodaysPnLPercent";
    AccountFeature[AccountFeature["RelativeDailyLossLimit"] = 70] = "RelativeDailyLossLimit";
    AccountFeature[AccountFeature["LiveLeverage"] = 71] = "LiveLeverage";
    AccountFeature[AccountFeature["AvailableCash"] = 72] = "AvailableCash";
    AccountFeature[AccountFeature["TotalPositionsValue"] = 73] = "TotalPositionsValue";
    AccountFeature[AccountFeature["FreeCommission"] = 74] = "FreeCommission";
    AccountFeature[AccountFeature["CurrentDailyLoss"] = 75] = "CurrentDailyLoss";
    AccountFeature[AccountFeature["CurrentDailyProfit"] = 76] = "CurrentDailyProfit";
    AccountFeature[AccountFeature["CopyTrading"] = 77] = "CopyTrading";
    AccountFeature[AccountFeature["BlockedForFixedIncome"] = 78] = "BlockedForFixedIncome";
    AccountFeature[AccountFeature["FixedIncomeOrdersReq"] = 79] = "FixedIncomeOrdersReq";
    AccountFeature[AccountFeature["FixedIncomeValue"] = 80] = "FixedIncomeValue";
    AccountFeature[AccountFeature["NegativeInterestRatePercent"] = 81] = "NegativeInterestRatePercent";
    //82,
    AccountFeature[AccountFeature["MaxDrawDownLevel"] = 83] = "MaxDrawDownLevel";
})(AccountFeature || (AccountFeature = {}));
